import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomSteps from '../../../../../v2-components/Antd/Steps';
import { dataSteps } from '../../constants/data-steps.constant';
import { handleDescription } from '../../handle/description.handle';
import { typeRetirement } from './handle/type-retirement.handle';

export default function ReserveProgress(props) {
	const progress = props?.data?.status_log;
	const filteredStatus = dataSteps[Enviroment.LANGUAGE].filter((s) => progress?.some((p) => p.status === s.status));
	const steps = filteredStatus.map((item, index) => {
		const description = progress?.filter((item) => item.status === filteredStatus[index].status);
		return {
			title: item.title,
			description: handleDescription(description),
		};
	});

	const current = steps.length - 1;

	return (
		<>
			<h4>{typeRetirement[Enviroment.LANGUAGE][props?.data?.pharmacy_detail?.type_retirement]}</h4>
			<p>
				Farmacia {props?.data?.pharmacy}, {props?.data?.pharmacy_detail?.direction}, {props?.data?.pharmacy_detail?.commune}, {props?.data?.pharmacy_detail?.region}
			</p>
			<CustomSteps progressDot size="small" direction="vertical" current={current} items={steps} />
		</>
	);
}
